import useClientConfig from "../../../../../config/careers/clientConfig";
import React from "react";

const AssaBanner = () => {
    const { clientAssetsLink, clientConfig } = useClientConfig();

    return (
        <>
            <div id="careers" className="home__careers ">
                <div className="assa">
                    <img src={clientAssetsLink + "/assa-banner.png"} alt="Banner" className="banner-img" />
                    <div className="logo-text-wrapper container mx-auto">
                        <div className="left-logo">
                            <img src={clientAssetsLink + "/career-logo.png"} alt="ASSA Logo" />
                        </div>
                        <div className="w-full container mx-auto banner-text">
                            <p>Swim schools and aquatic venues are packed with the kind of work that actually feels good at the end of the day. You help children and adults build confidence, learn a truly life-saving skill, and become safer around water. It’s social, active, purpose-led work with great people, and there are genuine pathways too. Start poolside or front-of-house, then grow into mentoring, supervision, coordination, customer experience, training, or venue leadership. Bring energy, care, and a willingness to learn, and there’s plenty of room to grow.</p>
                            <p>Welcome to the ASSA Industry Jobs Hub, built to connect SwimSchoolers with roles across our member network. ASSA is not an employer, we’re the industry body, so every job you see here is advertised by a swim school or aquatic operator and applications go directly to them. Browse the listings, find the right fit, and jump in. Whether you’re chasing your first role or your next step up, this is your place to start.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AssaBanner;